module.exports = __webpack_public_path__ + "static/media/cancer.9e277faf.jpg";